module.exports = __webpack_public_path__ + "img/skin.200fd79f.svg";